var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { Select } from "@reverb-ui/react";
import { Controller } from "react-hook-form";
export var ControlledFormSelect = function (_a) {
    var defaultValue = _a.defaultValue, fieldName = _a.fieldName, control = _a.control, rules = _a.rules, options = _a.options, isDisabled = _a.isDisabled, isLoading = _a.isLoading;
    return (React.createElement(Controller, { name: fieldName, control: control, rules: rules, render: function (_a) {
            var field = _a.field;
            return (React.createElement(Select, __assign({}, field, { options: options, isDisabled: isLoading || isDisabled, isLoading: isLoading })));
        } }));
};
